import { UseQueryOptions, useQuery } from '@hooks/react-query';
import { ApiError, ApiResult } from '@models/api';
import COOKIES_KEY from 'constants/cookies';
import { GetTokenResponse } from '../models';
import Cookies from 'js-cookie';

function useRGetActionLogToken(
  options?: UseQueryOptions<ApiResult<GetTokenResponse>, ApiError>,
) {
  const jwtToken = Cookies.get(COOKIES_KEY.JWT_TOKEN);
  return useQuery({
    queryKey: ['token'],
    enabled: !jwtToken,
    meta: {
      skipAuth: true,
    },
    ...options,
  });
}

export default useRGetActionLogToken;
